<template>
    <div class="bg-[var(--fundoForm)] w-full p-2 rounded-md flex justify-center items-center text-[var(--text)]">
        <form @submit.prevent="changePassword" class="flex flex-col items-left gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2">
            <h1 style="color: var(--titulo)">Alterar Senha</h1>
            <div class="w-full grid grid-cols-2 items-center gap-1">
                <!-- <h2 style="color: var(--label);">Utilizador: { {{ userName }} }</h2> -->
            </div>
            <div class="w-full grid grid-cols-2 items-center gap-1">
                <label for="old_password" style="color: var(--label);">Senha Antiga</label>
                <input
                  class="rounded-md p-1"
                  :class="{ 'input-required': !oldPassword }"
                  v-model="oldPassword" type="password" id="old_password" required />
            </div>
            <div class="w-full grid grid-cols-2 items-center gap-1">
                <label for="new_password" style="color: var(--label);">Nova Senha</label>
                <input
                  class="rounded-md p-1"
                  :class="{ 'input-required': !newPassword }"
                  v-model="newPassword" type="password" id="new_password" required />
            </div>
            <div class="w-full grid grid-cols-2 items-center gap-1">
                <label for="new_password_confirm" style="color: var(--label);">Confirmar Nova Senha</label>
                <input
                  class="rounded-md p-1"
                  :class="{ 'input-required': !newPasswordConfirm }"
                  v-model="newPasswordConfirm" type="password" id="new_password_confirm" required />
            </div>
            <div class="text-right">
                <button type="submit" class="button px-4 py-1 bg-sky-600 rounded-lg shadow-lg hover:bg-sky-700 text-white">Alterar Senha</button>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import permissionMixin from '@/permissionMixin.js';
import { toast } from 'vue3-toastify';

export default {
    mixins: [permissionMixin],
    data() {
        return {
            baseURL: process.env.VUE_APP_URL_BASE,
            oldPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
            userName: '',
        };
    },
    created() {
        this.loadUserData();
    },
    methods: {
        loadUserData() {
            const userLogado = JSON.parse(localStorage.getItem('user'));
            if (userLogado) {
                this.userName = userLogado.user;
            }
        },
        async changePassword() {
            if (this.newPassword !== this.newPasswordConfirm) {
                toast.error('As senhas não coincidem', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });
                return;
            }

            try {
                const response = await axios.post(`${this.baseURL}/api/v1/changePassword/`, {
                    user: this.userName,
                    password: this.oldPassword,
                    newPassword: this.newPassword,
                    confirmPassword: this.newPasswordConfirm,
                });

                if (response.data.status === 200) {
                    toast.success('Senha alterada com sucesso', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                    });
                } else {
                    const errorMessage = response.data.message || 'Erro ao alterar senha';
                    toast.error(errorMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                const errorMessage = error.response?.data.message || 'Erro desconhecido ao alterar a senha.';
                toast.error(errorMessage, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                });
            }
        }
    }
}
</script>
<style scoped>
.button {
  background-color: var(--button);
  color: var(--label);
  cursor: pointer;
}

.button[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}

.button:hover:not([disabled]) {
  filter: brightness(0.9);
}
</style>